// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ZeroState__zeroState___3MngX{display:flex;align-items:center;justify-content:center;flex-direction:column;height:100%;padding:24px;min-height:200px}.ZeroState__zeroState___3MngX{animation:appear-in 0.2s linear;animation-fill-mode:both}.ZeroState__zeroStateTitle___2kC6z{font-size:18px;font-weight:500;text-transform:uppercase;color:#AAA;margin-bottom:12px}.ZeroState__zeroStateOptions___1su7m{display:flex;align-items:center;justify-content:space-between}.ZeroState__zeroStateOptions___1su7m span{padding:0 12px;color:#BBB}\n", ""]);
// Exports
exports.locals = {
	"zeroState": "ZeroState__zeroState___3MngX",
	"zeroStateTitle": "ZeroState__zeroStateTitle___2kC6z",
	"zeroStateOptions": "ZeroState__zeroStateOptions___1su7m"
};
module.exports = exports;
